import { SVGProps } from 'react';
const SvgMinusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 17 2" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <rect x={0.5} width={16} height={2} rx={1} fill="currentColor" />
  </svg>
);
export default SvgMinusIcon;
